module.exports = __webpack_public_path__ + "static/img/caoxi.144cee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/caoxi.jpg
// module id = Yp/1
// module chunks = 0